import {types} from './types';

const initialState = {
    withdrawals: {
        data: [],
        countPage: 1
    },
}

export function withdrawalsMobileReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_WITHDRAWALS:
            return { ...state, withdrawals: action.payload};
        default:
            return state
    }
}